import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { FormBuilder } from 'shared-components/forms/form';
import { Helpers } from 'shared-components/helpers/helpers';

import { LocationWrapper } from '../partials-search-form/location-wrapper';
import { ActivitySearch } from '../partials-search-form/activity-search';
import { RadioGroup } from '../elements-inputs/radio-group';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';

import { MoreActivitiesBody } from '../flow-projects/project-more-activity';
import { FormattedMessage, injectIntl } from 'react-intl';

const dateToSchedule = (momentDate) => {
  const y = momentDate.year();
  // convert month to base 1
  const m = momentDate.month() + 1;
  const d = momentDate.date();

  return {
    date: { y, m, d }
  };
};

class ProjectDetailsSettingsModal extends Component {
  constructor (props) {
    super(props);

    const { project } = this.props;
    const { _id, name, description, activity, location, do_not_notify = false } = project;

    this.modalBody = this.modalBody.bind(this);
    this.renderSettingsForm = this.renderSettingsForm.bind(this);
    this.getValueFromInput = this.getValueFromInput.bind(this);
    this.saveSettings = this.saveSettings.bind(this);
    this.captureDate = this.captureDate.bind(this);
    this.handleUpdateError = this.handleUpdateError.bind(this);
    this.locationClickCallback = this.locationClickCallback.bind(this);
    this.renderActivityDropdown = this.renderActivityDropdown.bind(this);
    this.renderLocationDropdown = this.renderLocationDropdown.bind(this);
    this.renderActivityDate = this.renderActivityDate.bind(this);
    this.renderNotificationsRadio = this.renderNotificationsRadio.bind(this);
    this.activityClickCallback = this.activityClickCallback.bind(this);
    this.renderMoreActivities = this.renderMoreActivities.bind(this);
    this.selectPopularActivity = this.selectPopularActivity.bind(this);
    this.showDeleteConfirmation = this.showDeleteConfirmation.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.deleteBoard = this.deleteBoard.bind(this);
    this.notificationsRadioChange = this.notificationsRadioChange.bind(this);

    this.state = {
      _id,
      name,
      activity,
      location,
      description,
      do_not_notify,
      schedule: null,
      formError: '',
      moreActivities: false,
      useTypes: [],
      confirmDelete: false
    };
  }

  getValueFromInput (value, callback) {
    this.setState(value);
    return callback();
  }

  saveSettings (el, callback) {
    const { updateProject, accessToken, project: { _id }, descriptionAnalytics } = this.props;
    const { name, activity, location, description, schedule, do_not_notify } = this.state;
    const payload = Object.assign({}, {
      name,
      activity,
      location,
      description,
      do_not_notify
    });
    if (schedule) {
      let payloadDate;

      if (moment.isMoment(schedule)) {
        payloadDate = dateToSchedule(schedule);
      } else {
        payloadDate = schedule;
      }

      payload.schedule = [{
        start: payloadDate
      }];
    }
   
    return updateProject(_id, accessToken, payload)
      .then (res => {
        if (description !== this.props.project.description) {
          descriptionAnalytics('description added', { character_count: description.length });
        }
      })
      .then(callback)
      .catch(this.handleUpdateError);
  }

  handleUpdateError (err) {
    this.setState({
      formError: err
    });
  }

  validateInput (errorData, validState) {
    return validState(errorData);
  }

  selectPopularActivity (activity) {
    this.setState({
      activity,
      moreActivities: false
    });
  }

  moreActivitiesBody () {
    const { useTypes } = this.state;
    const alphaActivites = _.sortBy(useTypes, 'dropdown');

    return <MoreActivitiesBody useTypes={ alphaActivites } callback={ this.selectPopularActivity} />;
  }

  modalBody () {
    const { moreActivities } = this.state;

    if (moreActivities) {
      return this.moreActivitiesBody();
    }

    return (
      <div>
        <h3 className="title text-center">
          <FormattedMessage
            id="boards.project_details_settings_modal.edit_details"
            defaultMessage="Edit Details"
          />
        </h3>
        <div>
          { this.renderSettingsForm() }
        </div>
      </div>
    );
  }

  captureDate (date) {
    const momentDate = moment(date);
    this.setState({
      schedule: momentDate.isValid() ? momentDate : null
    });
  }

  locationClickCallback (location) {
    this.setState({
      location
    });
  }

  activityClickCallback (activity) {
    this.setState({
      activity
    });
  }

  renderLocationDropdown () {
    return (
      <LocationWrapper
        ref="location"
        location={ this.state.location }
        clickCallback={ this.locationClickCallback }
      />
    );
  }

  renderActivityDate () {
    const { project } = this.props;
    const schedule = this.state.schedule || project.schedule;
    let projectDate;
    moment.locale(this.props.intl.locale);

    if (moment.isMoment(schedule)) {
      projectDate = schedule.toDate();
    }

    // if schedule is in array format, convert to moment
    if (schedule.length && schedule[0].start) {
      projectDate = Helpers.convertScheduleToMoment(schedule).toDate();
    }

    return (
      <div>
        <div className='form-group has-feedback text-left'>
          <label
            htmlFor='activity-date-picker'
            className='control-label vert-align-label'
          >
            <FormattedMessage
              id='boards.project_details_settings_modal.activity_date'
              defaultMessage='Activity Date'
            />
          </label>
          <div>
            <DatePicker
              id='activity-date-picker'
              className='datepicker__input'
              dateFormat='MMM dd, yyyy'
              weekStart='0'
              onChange={this.captureDate}
              selected={projectDate || ''}
              minDate={moment().toDate()}
              placeholderText='optional'
              weekdays={moment.localeData().weekdaysMin()}
              moment={moment}
            />
          </div>
        </div>
      </div>
    );
  }

  renderMoreActivities (useTypes) {
    this.setState({
      useTypes,
      moreActivities: true
    });
  }

  renderActivityDropdown () {
    const { activity } = this.state;

    return (
      <div className="text-left margin-lg-top">
        <ActivitySearch
          ref="activity"
          clickCallback={ this.activityClickCallback }
          activity={ activity }
          seeMoreAction={ this.renderMoreActivities }
        />
      </div>
    );
  }

  notificationsRadioChange (selectedEle) {
    const notification = "do-not-notify" === selectedEle.id;

    this.setState({
      do_not_notify: notification
    });
  }


  renderNotificationsRadio () {
    const { do_not_notify } = this.state;

    return (
      <div className='form-inputs text-left margin-md-top'>
        <label className='control-label vert-align-label' for='notifications'>
          <FormattedMessage
            id='boards.project_details_settings_modal.notification'
            defaultMessage='Notifications'
          />
        </label>
        <p
          className='project-subtitle pull-left text-left'
          style={{ marginBottom: '16px' }}
        >
          <FormattedMessage
            id='boards.project_details_settings_modal.get_email'
            defaultMessage='Get email notifications when collaborators vote or comment.'
          />
        </p>
        <div className='project-boards-notifications-section'>
          <RadioGroup
            ref='radio'
            inputData={[
              {
                ID: 'do-notify',
                value: 'false',
                displayText: this.props.intl.formatMessage({
                  id: 'boards.project_details_settings_modal.radio_on',
                  defaultMessage: 'On'
                }),
                checked: !do_not_notify
              },
              {
                ID: 'do-not-notify',
                value: 'true',
                displayText: this.props.intl.formatMessage({
                  id: 'boards.project_details_settings_modal.radio_off',
                  defaultMessage: 'Off'
                }),
                checked: do_not_notify
              }
            ]}
            groupName='notifications'
            changeCB={this.notificationsRadioChange}
          />
        </div>
      </div>
    );
  }

  renderSettingsForm () {
    const { name, description, formError } = this.state;

    const inputs = [
      {
        customLabel: (
          <label style={{ display: 'block', textAlign: 'left' }}>
            {this.props.intl.formatMessage({
              id: 'boards.project_details_settings_modal.board_name_label',
              defaultMessage: 'Board Name'
            })}
          </label>
        ),
        placeholder: this.props.intl.formatMessage({
          id: 'boards.project_details_settings_modal.board_name_placeholder',
          defaultMessage: 'Board name'
        }),
        inputFieldName: 'board_name',
        elementID: 'name',
        ref: 'name',
        actionFn: this.getValueFromInput,
        actionCb: this.validateInput,
        labelSize: '',
        optional: false,
        defaultVal: name,
        customConstraints() {
          return;
        }
      },
      {
        custom: this.renderActivityDropdown
      },
      {
        custom: this.renderActivityDate
      },
      {
        custom: this.renderLocationDropdown
      },
      {
        customLabel: (
          <label className='block text-left'>
            {this.props.intl.formatMessage({
              id: 'boards.project_details_settings_modal.description',
              defaultMessage: 'Description'
            })}
          </label>
        ),
        placeholder: this.props.intl.formatMessage({
          id: 'boards.project_details_settings_modal.add_description',
          defaultMessage: 'Add a description to your board'
        }),
        inputFieldName: 'board_description',
        elementID: 'description',
        ref: 'description',
        actionFn: this.getValueFromInput,
        actionCb: this.validateInput,
        defaultVal: description
      },
      {
        custom: this.renderNotificationsRadio
      }
    ];

    return (
      <div className='padding-xl-left padding-xl-right'>
        <FormBuilder
          ref='projectDetailsSettings'
          formname='project details settings'
          formStyle='modal'
          formInputs={inputs}
          submitAction={this.saveSettings}
          submitCallback={this.props.closeSettingsModal}
          buttonText={this.props.intl.formatMessage({
            id: 'boards.project_details_settings_modal.save_button',
            defaultMessage: 'Save'
          })}
          btnColSize=''
          buttonClass='btn btn-lg btn-block btn-primary form'
          useBootstrapGrid={false}
          errorText={formError || ''}
          afterCTA={
            <div>
              <button
                className='btn btn-link'
                style={{ marginTop: '8px' }}
                name='delete this board'
                onClick={this.confirmDelete}
              >
                <FormattedMessage
                  id='boards.project_details_settings_modal.delete'
                  defaultMessage='Delete'
                />
              </button>
            </div>
          }
        />
      </div>
    );
  }

  deleteBoard (el, callback) {
    const { accessToken, project: { _id, external_id }, deleteBoard } = this.props;
    return deleteBoard(_id, accessToken, external_id)
      .then(callback)
      .then(() => {
        analyticsIntegrations.genericBoardAction('delete board', _.get(this.props, 'project', {}), {});
      })
      .catch(this.handleUpdateError);
  }

  confirmDelete () {
    this.setState({ confirmDelete: true });
  }

  cancelDelete () {
    this.setState({ confirmDelete: false });
  }

  showDeleteConfirmation () {
    return (
      <div id="confirm-board-delete">
        <h3 className="text-center" style={ { marginBottom: '24px' } }>
          <FormattedMessage
            id="boards.project_details_settings_modal.are_you_sure"
            defaultMessage="Are you sure you want to delete this board?"
          />
        </h3>
        <FormBuilder
          ref="projectDetailsSettingsDelete"
          formname="project details settings delete"
          formStyle="modal"
          formInputs={[]}
          submitAction={this.deleteBoard}
          submitCallback={this.props.boardHasBeenDeleted}
          buttonText={this.props.intl.formatMessage({ id: 'boards.project_details_settings_modal.yes_delete', defaultMessage: 'Yes, delete' })}
          buttonClass="btn btn-lg btn-block btn-primary form"
          useBootstrapGrid={false}
          errorText={this.state.formError || ''}
          afterCTA={ <button className="btn btn-link" style={ { marginTop: '8px' } } name="do not delete board" onClick={ this.cancelDelete }>
            <FormattedMessage
              id="boards.project_details_settings_modal.cancel"
              defaultMessage="Cancel"
            />
          </button> }
        />
      </div>
    );
  }

  render () {
    const modalBody = this.state.confirmDelete ? this.showDeleteConfirmation() : this.modalBody();
    return (
      <BootstrapModal
        {...this.props}
        body={modalBody}
        modalSize="sm-size"
        modalClass="project-flow project-modal-edit"
        onClose={this.props.closeSettingsModal}
      />
    );
  }
}

ProjectDetailsSettingsModal.propTypes = {
  project: PropTypes.object,
  accessToken: PropTypes.string,
  updateProject: PropTypes.func,
  deleteBoard: PropTypes.func,
  boardHasBeenDeleted: PropTypes.func,
  closeSettingsModal: PropTypes.func,
  toggleModal: PropTypes.func,
  descriptionAnalytics: PropTypes.func
};

exports.ProjectDetailsSettingsModal = injectIntl(ProjectDetailsSettingsModal, { withRef: true });
